module.exports = __webpack_public_path__ + "img/like.c9382f5c.svg";